export default {
  computed: {
    valvesStateStyles() {
      return [
        {
          externalGraphic: 'valves_closed.svg',
          'icon-size': 2,
          'fill-opacity': 1,
          minzoom: 1,
          text: 'close',
        },
        {
          externalGraphic: 'valves_open.svg',
          'icon-size': 2,
          'fill-opacity': 1,
          minzoom: 1,
          text: 'open',
        },
        {
          externalGraphic: 'valves_noinfo.svg',
          'icon-size': 2,
          'fill-opacity': 1,
          minzoom: 1,
          text: 'noData',
        },
        {
          externalGraphic: 'excluded.svg',
          'icon-size': 2,
          'fill-opacity': 1,
          minzoom: 1,
          text: 'excluded',
        },
        {
          externalGraphic: 'valves_toclose.svg',
          'icon-size': 2,
          'fill-opacity': 1,
          minzoom: 1,
          text: 'toClose',
        },
      ];
    },
  },
};
